import { Container } from "pixi.js";

import { getMobileDetect } from "../../config/GlobalVariableConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Meter } from "./Meter";


export class MeterComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        let containerConfig = {
            labelName: "meter_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: getMobileDetect() ? 350 : 397,
                posY: getMobileDetect() ? 1260 : 1346,
                scale: getMobileDetect() ? 0.6 : 0.7,
            },
            portrait: {
                posX: 1024,
                posY: 1050,
                scale: 0.9,
            }
        };

        this.container = new Meter(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public highlight(id: number, callback: () => void) {
        (this.container as Meter).highlight(id, callback);
    }

    public updateMeterText(collectedScarabs: number, scarabRemaining: number) {
        (this.container as Meter).updateMeterText(collectedScarabs, scarabRemaining);
    }

    public activate(callback: () => void) {
        (this.container as Meter).activate(callback);
    }

    public deActivate(id: number) {
        (this.container as Meter).deActivate(id);
    }

    public startIdle() {
        (this.container as Meter).startIdleChain(true);
    }

    public resumeIdle() {
        (this.container as Meter).startIdleChain(false);
    }

    public stopIdle() {
        (this.container as Meter).stopIdleChain();
    }

    public upgradeCurrentJackpotValue(callback: () => void) {
        (this.container as Meter).upgradeCurrentJackpotValue(callback);
    }

    public getCurrentActiveMeter() {
        return (this.container as Meter).getCurrentActiveMeter();
    }
    public getCurrentBaseGameActiveMeter(id: number) {
        return (this.container as Meter).getCurrentBaseGameActiveMeter(id);
    }

    public getActiveMeterId() {
        return (this.container as Meter).getActiveMeterId();
    }

    public getCurrentWonJackpotValue(): number {
        return (this.container as Meter).getCurrentWonJackpotValue();
    }
}
